import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { integrationsStateSelector } from "./integrationsStateSelector";

export const currentIntegrationTypeSelector = createDraftSafeSelector(
  [integrationsStateSelector],
  (integrations) => {
    return integrations.currentIntegrationType;
  },
);
